<template>
	<div
		v-if="!loading"
		class="container"
		dusk="job-offer">
		<img
			src="/assets/img/abdom-logo.png"
			class="img-fluid mb-4 mx-auto d-block"
			width="200px">
		<h1 class="text-center">
			Job Offer
		</h1>
		<template v-if="['Accepted', 'Confirmed'].includes(job_offer.status)">
			<p class="text-center">
				You have accepted this job.
			</p>
		</template>
		<template v-if="job_offer.status === 'Declined'">
			<p class="text-center">
				You have declined this job.
			</p>
		</template>
		<template v-if="job_offer.status === 'Revoked'">
			<p class="text-center">
				This job offer is no longer available.
			</p>
		</template>
		<template v-if="['Pending', 'Requested'].includes(job_offer.status )">
			<div class="alert alert-warning">
				You have {{ time_remaining }} left to action this job offer.
			</div>
			<job-offer-service
				v-if="job_offer.services.length"
				:offer="job_offer"></job-offer-service>
			<job-offer-booking
				v-else-if="job_offer.booking" :model-value="selected_days"
				:offer="job_offer"
				@update:model-value="selected_days = $event"></job-offer-booking>
			<BOverlay :show="!!timeToCanAction">
				<template #overlay>
					This job can be accepted in {{ timeToCanAction }}
				</template>
				<div class="mb-3">
					<BButtonGroup class="special">
						<BButton
							variant="danger"
							:disabled="submitting"
							@click="decline">
							Decline
						</BButton>
						<BButton
							variant="success"
							:disabled="submitting"
							@click="accept">
							Accept
						</BButton>
					</BButtonGroup>
				</div>
			</BOverlay>
		</template>
	</div>
</template>

<script>
	import JobOfferBooking from './JobOfferBooking.vue';
	import JobOfferService from './JobOfferService.vue';

	export default {
		name: 'JobOffer',
		components: {JobOfferService, JobOfferBooking},
		props: {
			uuid: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				job_offer: {
					booking: {},
					services: []
				},
				loading: true,
				selected_days: [],
				time_remaining: null,
				submitting: false,
				timeToCanAction: null
			}
		},
		computed: {
			user() {
				return this.$store.getters['auth/user']
			}
		},
		mounted() {
			this.fetchJobOffer();
		},
		beforeUnmount() {
			clearInterval(this.$options.interval)
		},
		methods: {
			fetchJobOffer() {
				this.loading = true;

				this.$axios.get(`/api/job-offers/${this.uuid}`).then(response => {
					this.job_offer = response.data.data;
					this.updateRemainingTime()
					this.checkCanAction()
					this.$options.interval = setInterval(this.updateRemainingTime, 1000)
				}).finally(() => {
					this.loading = false;
				})
			},
			accept() {
				this.submitting = true;
				this.$axios.post(`/api/job-offers/${this.uuid}/accept`, {
					days: this.selected_days
				}).then(() => {
					this.job_offer.status = 'Accepted';
				}).catch(error => {
					if (error.response && error.response.status === 422) {
						toastr.error(error.response.data.errors.days.join(', '))
						return;
					}

					this.fetchJobOffer();
					toastr.error('An error occurred.');

					if(!error.response) {
						throw error;
					}
				}).finally(() => {
					this.submitting = false;
				})
			},
			decline() {
				this.submitting = true;
				this.$axios.post(`/api/job-offers/${this.uuid}/decline`).then(() => {
					this.job_offer.status = 'Declined';
				}).catch(() => {
					this.fetchJobOffer();
					toastr.error('An error occurred.');
				}).finally(() => {
					this.submitting = false;
				})
			},
			updateRemainingTime() {
				const end = moment.parseZone(this.job_offer.expires_at)
				const diff = moment(end).diff(moment())
				const duration = moment.duration(diff)

				const hours = parseInt(duration.asHours())
				const minutes = parseInt(duration.asMinutes()) % 60
				const seconds = parseInt(duration.asSeconds()) % 60

				this.time_remaining = hours + 'h ' + minutes + 'm ' + seconds + 's'
			},
			checkCanAction() {
				if(this.job_offer.status !== 'Requested') {
					this.timeToCanAction = null;
					return
				}

				const start = moment()
				const end = moment.parseZone(this.job_offer.created_at).add(15, 'minutes')
				const duration = moment.duration(end.diff(start))

				if(0 > duration.asMinutes()) {
					this.timeToCanAction = null;
					return
				}

				this.timeToCanAction = `${duration.minutes()}m ${duration.seconds()}s`

				setTimeout(() => this.checkCanAction(), 1000)
			}
		}
	}
</script>

<style scoped>
	.btn-group.special {
		display: flex;
	}

	.special .btn {
		flex: 1
	}
</style>
